<template>
	<section class="i-calendar">
		<section class="i-calendar__calendar">
			<div
				v-if="investorsDataIsLoading || investorsData"
				class="i-calendar__component"
			>
				<loader v-if="loader" />
				<checkboxes
					v-if="investorsData"
					:data="emitentsList"
					:choosen-emitent="emitent"
					@modelChange="filterCalendarItems"
				/>
				<almanac
					v-if="investorsData"
					:api-data="investorsData.data"
					:marks="filteredMarks"
					@changeMonth="updateApiData"
				/>
			</div>
		</section>
		<Transition name="slide-fade">
			<section
				v-if="eventsIsLoading || eventCards.length > 0"
				class="i-calendar__events"
			>
				<loader v-if="eventsIsLoading" />
				<div class="i-calendar__wrap">
					<h2 class="i-calendar__events-title" title="Все события">
						Все события
					</h2>
					<div class="i-calendar__list">
						<events-card
							v-for="card in eventCards"
							:key="card.id"
							:card="card"
						/>
					</div>
				</div>
			</section>
		</Transition>
	</section>
</template>

<script>
import Loader from '../vue-components/Loader'
import Checkboxes from './components/Checkboxes'
import Almanac from './components/Almanac'
import EventsCard from './components/EventsCard'
import { investorsDataActionTypes } from '../store/modules/investors/investors'
import { mapState } from 'vuex'

export default {
	name: 'Calendar',
	components: {
		Loader,
		Checkboxes,
		Almanac,
		EventsCard,
	},
	computed: {
		...mapState({
			investorsDataIsLoading: state => state.investorsData.isLoading,
			investorsData: state => state.investorsData.data,
			investorsDataError: state => state.investorsData.error,
			eventsIsLoading: state => state.investorsData.eventsIsLoading,
			events: state => state.investorsData.events,
			eventsError: state => state.investorsData.eventsError,
		}),

		getDateNow() {
			const newDate = new Date()
			return `?month=${newDate.getFullYear()}-${(newDate.getMonth() + 1)
				.toString()
				.padStart(2, '0')}`
		},
	},

	methods: {
		filterCalendarItems(Arr) {
			this.filteredMarks = []

			if (Arr[0] === 'emitents-all') {
				this.filteredMarks = this.emitentsList.items
			} else {
				this.emitentsList.items.forEach(element => {
					if (Arr.includes(element.id)) {
						if (!this.filteredMarks.includes(element)) {
							this.filteredMarks.push(element)
						}
					}
				})
			}

			this.sortEventCards()
		},

		updateApiData(monthYear) {
			this.$store.dispatch(investorsDataActionTypes.getInvestorsData, {
				apiUrl: this.apiUrl,
				filter: `?month=${monthYear}`,
			})
			this.loaderTrottle()
		},

		sortEventCards() {
			const categories = this.filteredMarks.map(el => el.id)

			if (categories.length > 0) {
				this.urlParams = '?emitent=' + categories.join(',')
				history.pushState(
					null,
					null,
					`${window.location.href.split('?')[0]}${this.urlParams}`
				)
			}

			this.eventCards = []

			if (this.events?.data.length > 0) {
				this.events.data.forEach(element => {
					categories.forEach(category => {
						if (element.category_code === category) {
							this.eventCards.push(element)
						}
					})
				})

				this.eventCards = this.eventCards.slice(0, 3)
			}
		},

		loaderTrottle() {
			setTimeout(() => {
				if (this.investorsDataIsLoading) {
					this.loader = true
					this.loaderTrottle()
					return
				}

				this.loader = false
			}, 1000)
		},
	},

	watch: {
		events() {
			this.sortEventCards()
		},
	},

	data() {
		return {
			apiUrl: '/api/v2/content/investors/calendar/',
			urlParams: '',
			loader: true,
			emitent: '',
			emitentsList: {
				name: 'emitents',
				items: [
					{
						id: 'events',
						text: 'IR мероприятия',
						color: '#82BF00',
					},
					{
						id: 'reports',
						text: 'Регулярная отчётность',
						color: '#9AC2FF',
					},
					{
						id: 'bonds',
						text: 'Облигации',
						color: '#FAD248',
					},
				],
			},
			filteredMarks: [],
			eventCards: [],
		}
	},
	beforeMount() {
		if (window.location.search.indexOf('emitent=') !== -1) {
			this.emitent = window.location.search.split('emitent=')[1].split('&')[0]
			this.emitent = this.emitent.split(',')

			this.emitent.forEach(emitent => {
				this.emitentsList.items.forEach(element => {
					if (emitent === element.id) {
						this.filteredMarks.push(element)
					}
				})
			})
		} else {
			this.filteredMarks = this.emitentsList.items
		}
		this.$store.dispatch(investorsDataActionTypes.getInvestorsData, {
			apiUrl: this.apiUrl,
			filter: this.getDateNow,
		})
		this.$store.dispatch(investorsDataActionTypes.getCalendarEvents, {
			apiUrl: this.apiUrl,
		})
		this.loaderTrottle()
	},
}
</script>
